// extracted by mini-css-extract-plugin
module.exports = {"staticPagesMenu":"styles_staticPagesMenu__wv_pr","staticPagesMenuItem":"styles_staticPagesMenuItem__0N5uH","active":"styles_active__HEIOE"};